import { render } from "./ComboStatusPedido.vue?vue&type=template&id=928dc854&ts=true"
import script from "./ComboStatusPedido.vue?vue&type=script&lang=ts"
export * from "./ComboStatusPedido.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\OnSeller\\FrontEnd\\Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__